module.exports = __webpack_public_path__ + "officialStatic/img/n5.6b64810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/n5.png
// module id = aBJb
// module chunks = 0